module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title_media":"Attach Photos/Video","title_image":"Attach Photos","add_image":"Attach Photos","add_video":"Attach Videos","disclaimer":"Personal information disclosure (CCTV/Black Box), defamation, copyright, etc. are subject to sanctions under the Terms of Use and the relevant laws."}}')
  delete Component.options._Ctor
}
